export default __webpack_public_path__ + "static/media/wave2thefuture.4f735b8e.png";